import { Modal, Button } from 'react-bootstrap';
import { useSelector } from "react-redux";
import useT from "../../i18n/useT";

const AddNewUser = ({show, setShow, formData, setFormData, submit, loading, type}) => {
    const role = useSelector((state) => state.user.role);
    const t = useT();

    return(
        <Modal show={show} onHide={() => setShow(false)} size='lg' centered>
            <Modal.Header closeButton><h3>{type === "edit" ? t("users.editTitle") : t("users.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form className='row' onSubmit={submit}>
                    {
                        (role === "admin" || role === "moderator") && (
                            <div className='col-md-6'>
                                <div className='form-group mb-4'>
                                    <label>{t("users.calculatorCategory")}:</label>
                                    <select name="calculator_category" className='form-control' type='text' required  value={formData.calculator_category} onChange={(e) => setFormData((prev) => ({...prev, calculator_category: e.target.value}))}>
                                        <option value={""}>{t("users.selectCategory")}</option>
                                        <option value={"A"}>A</option>
                                        <option value={"B"}>B</option>
                                        <option value={"C"}>C</option>
                                        <option value={"D"}>D</option>
                                        <option value={"E"}>E</option>
                                        <option value={"F"}>F</option>
                                        <option value={"G"}>G</option>
                                        <option value={"H"}>H</option>
                                    </select>
                                </div>
                            </div>
                        )
                    }
                    {
                        role === "superviser" && <div className='col-md-6'>
                            <div className='form-group mb-4'>
                                <label>{t("users.superviserFee")}:</label>
                                <input name="superviser_fee" className='form-control' type='text' required placeholder={t("users.phSuperviserFee")} value={formData.superviser_fee} onChange={(e) => setFormData((prev) => ({...prev, superviser_fee: e.target.value}))}/>
                            </div>
                        </div>
                    }
                    {
                        (role === "admin" || role === "moderator") && (
                            <div className='col-md-6'>
                                <div className='form-group mb-4'>
                                    <label>{t("users.role")}:</label>
                                    <select name="calculator_category" className='form-control' type='text' required  value={formData.role} onChange={(e) => setFormData((prev) => ({...prev, role: e.target.value}))}>
                                        <option value={""}>{t("users.selectRole")}</option>
                                        <option value={"admin"}>{t("users.roleAdmin")}</option>
                                        <option value={"moderator"}>{t("users.roleModerator")}</option>
                                        <option value={"superviser"}>{t("users.roleSuperviser")}</option>
                                        <option value={"dispecher"}>{t("users.roleDispecher")}</option>
                                        <option value={"user"}>{t("users.roleUser")}</option>
                                    </select>
                                </div>
                            </div>
                        )
                    }
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.name")}:</label>
                            <input name="name" className='form-control' type='text' required placeholder={t("users.phName")} value={formData.name} onChange={(e) => setFormData((prev) => ({...prev, name: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.surname")}:</label>
                            <input name="surname" className='form-control' type='text' required placeholder={t("users.phSurname")} value={formData.surname} onChange={(e) => setFormData((prev) => ({...prev, surname: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.identityNumber")}:</label>
                            <input name="identity_number" className='form-control' type='text' required placeholder={t("users.phIdentityNumber")} value={formData.identity_number} onChange={(e) => setFormData((prev) => ({...prev, identity_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.phone")}:</label>
                            <input name="phone" className='form-control' type='text' required placeholder={t("users.phPhone")} value={formData.phone} onChange={(e) => setFormData((prev) => ({...prev, phone: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.email")}:</label>
                            <input name="email" className='form-control' type='text' required placeholder={t("users.phEmail")} value={formData.email} onChange={(e) => setFormData((prev) => ({...prev, email: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("users.username")}:</label>
                            <input name="username" className='form-control' type='text' required placeholder={t("users.phUsername")} value={formData.username} onChange={(e) => setFormData((prev) => ({...prev, username: e.target.value}))}/>
                        </div>
                    </div>

                    {type === "add" && <>
                        <div className='col-md-6'>
                            <div className='form-group mb-4'>
                                <label>{t("users.password")}:</label>
                                <input name="password" className='form-control' type='password' required placeholder={t("users.phPassword")} value={formData.password} onChange={(e) => setFormData((prev) => ({...prev, password: e.target.value}))}/>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group mb-4'>
                                <label>{t("users.confirmPassword")}:</label>
                                <input name="password" className='form-control' type='password' required placeholder={t("users.phConfirmPassword")} value={formData.confirm_password} onChange={(e) => setFormData((prev) => ({...prev, confirm_password: e.target.value}))}/>
                            </div>
                        </div>
                    </>}
                    <Modal.Footer>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewUser